module.exports = __webpack_public_path__ + "img/default2.0b9a25b5.png";